import { DefaultError, useQueryClient } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { digitalDeliveryTemplateInitialValues } from 'components/organisms/forms/settings/DigitalDeliveryTemplateForm';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteDeliveryTemplate,
  useGetDeliveryTemplate,
} from 'services/settings/digital-delivery-template';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowToast } from 'utils/service/errorHandler';

const Detail = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data, isLoading, refetch } = useGetDeliveryTemplate();

  const deleteDeliveryTemplate = useDeleteDeliveryTemplate();

  const handleDelete = useCallback(
    async (actions: PopupActions) => {
      try {
        await deleteDeliveryTemplate.mutateAsync(undefined, {
          onSuccess: async () => {
            actions.close();
            await queryClient.removeQueries({ queryKey: ['deliveryTemplate'] });
            await refetch();
          },
        });
      } catch (error) {
        actions.close();
        onErrorShowToast(error as DefaultError);
      }
    },
    [deleteDeliveryTemplate, queryClient, refetch],
  );

  return (
    <Form.DigitalDeliveryTemplate
      i18nextPrefix=''
      status={{
        displayMode: true,
        isLoading,
      }}
      initialValues={
        data
          ? {
              included: data.included ?? [],
              excluded: data.excluded ?? [],
            }
          : digitalDeliveryTemplateInitialValues
      }
      topbarContent={
        <div className='flex justify-end gap-2'>
          {data ? (
            <>
              <Button
                isClear
                onlyIcon
                onClick={() =>
                  navigate('/settings/digital-delivery-template/edit')
                }>
                <Button.Description description={t('button.edit')} />

                <Button.Icon icon={<PiPencilSimpleLine />} />
              </Button>
              <MagellanPopups.DeleteWarning
                name={t('setting.digital-delivery-template.name')}
                onRemove={handleDelete}
              />
            </>
          ) : (
            <Button
              variant={BUTTON_VARIANT.submit}
              onClick={() =>
                navigate('/settings/digital-delivery-template/create')
              }>
              <Button.Text text={t('button.create')} />
            </Button>
          )}
        </div>
      }
      onSubmit={() => {}}
    />
  );
};

export default Detail;
